import { render, staticRenderFns } from "./CaseArrhythmia.vue?vue&type=template&id=0493d5fa&scoped=true"
import script from "./CaseArrhythmia.vue?vue&type=script&lang=js"
export * from "./CaseArrhythmia.vue?vue&type=script&lang=js"
import style0 from "./CaseArrhythmia.vue?vue&type=style&index=0&id=0493d5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493d5fa",
  null
  
)

export default component.exports